/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */

import { Box, MenuItem, TextField } from "@mui/material";
import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { ThemButton } from "../../Login/Login.style";
import { ErrorMessage } from "../../Volunteer/Volunteer.style";
import { useDispatch } from "react-redux";
import { handleAddClose } from "../../../redux/Reducer/ModalSlice";
import { ToastContainer, Zoom, toast } from "react-toastify";

const data = [
  { sl: 101, Menu_name: "Dashboard", active_status: true },
  { sl: 102, Menu_name: "Security", active_status: false },
  { sl: 103, Menu_name: "Setup", active_status: true },
  { sl: 104, Menu_name: "Volunteer Bank", active_status: true },
  { sl: 105, Menu_name: "Study Compliance", active_status: false },
];

const AddSubmenu = ({ moduleInfo, refetch }) => {
  const [isLoading, setIsLoading] = useState();

  const {
    register,
    formState: { errors },
    handleSubmit,
    control,
    reset,
  } = useForm();

  const onSubmit = (data, e) => {
    const dispatch = useDispatch;
    alert(JSON.stringify(data));
    setIsLoading(true);
    const formData = new FormData();
    formData.append("sa_module_id", data.sa_module_id);
    formData.append("sa_mlink_name", data.sa_mlink_name);
    formData.append("url_uri", data.url_uri);

    fetch(
      `http://192.168.0.173/kyamch_ctms_backend_qa/api/storeModuleLinkSetup`,
      // `http://192.168.0.173/kyamch_ctms_backend_qa/api/createVoluntary`,
      {
        method: "POST",
        body: formData,
      }
    )
      .then((res) => {
        // console.log(res);
        // console.log("res", res);
        return res.json();
      })
      .then((data) => {
        // console.log("data", data);
        if (data.success === true) {
          // console.log("111111");
          dispatch(handleAddClose());

          refetch();
        } else if (data.duplicate === true) {
          toast.error("Module Name is already exists!!", {
            position: toast.POSITION.TOP_CENTER,
          });
        }
      })
      .finally(() => setIsLoading(false));
  };

  const filteredData = moduleInfo.filter((obj) => obj.active_fg === "Y");

  // console.log("filteredData", filteredData);
  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <Box p="20px">
        <TextField
          select
          size="small"
          fullWidth
          label="Module Name*"
          variant="outlined"
          {...register("sa_module_id", {
            required: true,
          })}
        >
          {filteredData?.map((menu) => (
            <MenuItem key={Math.random()} value={menu.module_id}>
              {menu.module_name}
            </MenuItem>
          ))}
        </TextField>

        {errors?.Menu_name?.type === "required" && (
          <ErrorMessage>Module Name is required</ErrorMessage>
        )}
      </Box>

      <Box px="20px" pb="20px">
        <TextField
          size="small"
          fullWidth
          label="Submenu Name*"
          variant="outlined"
          {...register("sa_mlink_name", {
            required: true,
            // pattern: /^[a-zA-Z]+$/,
          })}
        />
        {errors?.sa_mlink_name?.type === "required" && (
          <ErrorMessage>Submenu Name is required</ErrorMessage>
        )}
      </Box>

      <Box px="20px" pb="20px">
        <TextField
          size="small"
          fullWidth
          label="Submenu Route*"
          variant="outlined"
          {...register("url_uri", {
            required: true,
            // pattern: /^[a-zA-Z]+$/,
          })}
        />
        {errors?.url_uri?.type === "required" && (
          <ErrorMessage>submenu Name is required*</ErrorMessage>
        )}
      </Box>

      <Box sx={{ mb: "15px", display: "flex", justifyContent: "center" }}>
        <ThemButton
          style={
            {
              //   width: "30%",
            }
          }
          type="submit"
        >
          Add
        </ThemButton>
      </Box>

      <ToastContainer
        autoClose={2000}
        limit={1}
        transition={Zoom}
        toastStyle={{ border: "2px solid crimson" }}
      />
      {/* <Box sx={{ mb: "15px", display: "flex", justifyContent: "center" }}>
        {isLoading ? (
          <ThemButton
            style={
              {//   width: "30%",
              }
            }
            type="submit"
          >
            <SyncLoader color="#FFFFFF" size={8} />
          </ThemButton>
        ) : (
          <ThemButton
            style={
              {
                
              }
            }
            type="submit"
          >
            Add User Level
          </ThemButton>
        )}

        <ToastContainer
          autoClose={2000}
          limit={1}
          transition={Zoom}
          toastStyle={{ border: "2px solid crimson" }}
        />
      </Box> */}
    </form>
  );
};

export default AddSubmenu;
